import { render, staticRenderFns } from "./VimeoPlayer.vue?vue&type=template&id=502376ed&scoped=true&"
import script from "./VimeoPlayer.vue?vue&type=script&lang=js&"
export * from "./VimeoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VimeoPlayer.vue?vue&type=style&index=0&id=502376ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502376ed",
  null
  
)

export default component.exports